export interface MarketStudyState {
  marketStudies: any;
}

export const initialStateType = {
  marketStudies: [],
};
